module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/efo_features_09-1fd4bac755c0a04692f1aa5274353ef9.png";